import React from 'react';

function ChamadoSolicitanteField({ value, onChange, data = [], id = 'chamado-solicitante' }) {
    return (
        <div className="chamado-create-field">
            <label htmlFor={id}>Solicitante</label>
            <select
                id={id}
                value={value}
                onChange={(e) => onChange(e.target.value)}
            >
                <option value="">Selecione...</option>
                {data.map((opt) => (
                    <option key={opt.sequencia} value={opt.sequencia}>
                        {opt.nome}
                    </option>
                ))}
            </select>
        </div>
    );
}

export default ChamadoSolicitanteField;
